import React from "react";
import {ContactUs} from "../../components/contact-us/ContactUs";
import './ContactPage.scss'

export const ContactPage = () => (
    <div className='contact'>
        <ContactUs/>
    </div>
)